export default "__VITE_ASSET__SNabK4Ar__"